import React from "react";
import PharmacyDashboard from "../layouts/Backend/Pharmacy/Dashboard";
import PharmacyProtectedRoute from "../ProtectedRoute";
import Placeholder from "../layouts/Backend/Pharmacy/Placeholder";
import Inventory from "../layouts/Backend/Pharmacy/Inventory";
import LowStock from "../layouts/Backend/Pharmacy/LowStock";
import UpcomingExpiry from "../layouts/Backend/Pharmacy/UpcomingExpiry";
import PharmacyProfileSettings from "../layouts/Backend/Pharmacy/ProfileSettings";
import PharmacyProducts from "../layouts/Backend/Pharmacy/Products";
import PharmacyAccountSettings from "../layouts/Backend/Pharmacy/AccountSettings";
import NewOrders from "../layouts/Backend/Pharmacy/NewOrders";
import OrderHistory from "../layouts/Backend/Pharmacy/OrderHistory";
import Procurement from "../layouts/Backend/Pharmacy/Procurement";
import Packages from "../layouts/Backend/Pharmacy/Packages";
import PharmacyMySavedItems from "../layouts/Backend/Pharmacy/MySavedItems";
import CommonLayout from "../layouts/CommonLayout";

const withCommonLayout = (component) => (
    <PharmacyProtectedRoute>
        <CommonLayout userType="pharmacy">{component}</CommonLayout>
    </PharmacyProtectedRoute>
);

const PharmacyRoutes = [
    { path: "/pharmacy/dashboard", element: withCommonLayout(<PharmacyDashboard />) },
    {
        path: "/pharmacy/inbox",
        element: withCommonLayout(
            <Placeholder
                title="Inbox / Messages"
                description="Communicate with customers regarding prescriptions or order issues."
            />
        ),
    },
    {
        path: "/pharmacy/profilesettings/pharmacy-details",
        element: withCommonLayout(<PharmacyProfileSettings />),
    },
    {
        path: "/pharmacy/profilesettings/:sublink",
        element: withCommonLayout(<PharmacyProfileSettings />),
    },
    {
        path: "/pharmacy/specialitiesservices",
        element: withCommonLayout(
            <Placeholder
                title="Specialities & Services"
                description="Manage the services and specialities offered by the pharmacy."
            />
        ),
    },
    {
        path: "/pharmacy/accountsettings/Security_&_Settings",
        element: withCommonLayout(<PharmacyAccountSettings />),
    },
    {
        path: "/pharmacy/accountsettings/:sublink",
        element: withCommonLayout(<PharmacyAccountSettings />),
    },
    { path: "/pharmacy/products", element: withCommonLayout(<PharmacyProducts />) },
    { path: "/pharmacy/orders/new", element: withCommonLayout(<NewOrders />) },
    { path: "/pharmacy/orders/history", element: withCommonLayout(<OrderHistory />) },
    { path: "/pharmacy/inventory", element: withCommonLayout(<Inventory />) },
    { path: "/pharmacy/inventory/low-stock", element: withCommonLayout(<LowStock />) },
    { path: "/pharmacy/inventory/expiry", element: withCommonLayout(<UpcomingExpiry />) },
    { path: "/pharmacy/procurement", element: withCommonLayout(<Procurement />) },
    {
        path: "/pharmacy/financials",
        element: withCommonLayout(
            <Placeholder title="Financial Overview" description="Track income, expenses, and payouts." />
        ),
    },
    {
        path: "/pharmacy/invoices",
        element: withCommonLayout(
            <Placeholder title="Invoices (Sales)" description="Sales invoices and reports." />
        ),
    },
    {
        path: "/pharmacy/vendor-invoices",
        element: withCommonLayout(
            <Placeholder title="Vendor Invoices (Purchase)" description="Invoices from suppliers." />
        ),
    },
    {
        path: "/pharmacy/payoutssettings",
        element: withCommonLayout(
            <Placeholder title="Payouts Settings" description="Manage bank details for payouts." />
        ),
    },
    {
        path: "/pharmacy/sales-reports",
        element: withCommonLayout(
            <Placeholder title="Sales Reports" description="Sales volume and revenue reports." />
        ),
    },
    { path: "/pharmacy/packages", element: withCommonLayout(<Packages />) },
    { path: "/pharmacy/packages/:sublink", element: withCommonLayout(<Packages />) },
    {
        path: "/pharmacy/marketing",
        element: withCommonLayout(
            <Placeholder title="Marketing & Promotions" description="Run offers and discounts." />
        ),
    },
    {
        path: "/pharmacy/prescriptions",
        element: withCommonLayout(
            <Placeholder
                title="Prescription Requests"
                description="Review and verify uploaded prescriptions."
            />
        ),
    },
    { path: "/pharmacy/mysaveditems", element: withCommonLayout(<PharmacyMySavedItems />) },
];

export default PharmacyRoutes;
